<div class="swing-container">
  <div class="swing-header">
    <h3 *ngIf="!canManageOtherSessions">My Sessions</h3>
    <div class="form-group" *ngIf="canManageOtherSessions" style="min-width:35%">
      <label>Sessions for:</label>
      <select
          id="username"
          name="username"
          [(ngModel)]="selectedUsername"
          (ngModelChange)="getSessionsForSelectedUser()"
          #username="ngModel">
          <option *ngFor="let u of users" [value]="u.username">
            {{ u.firstName }} {{ u.lastName }}
          </option>
        </select>
    </div>
    <button class="btn" *ngIf="loggedInUserIsAdmin" (click)="newSession()">New Session</button>
    
  </div>

  <div class="swing-grid">
    <div 
      class="swing-card" 
      *ngFor="let session of sessions; trackBy: trackByDate"
      (click)="onSessionClick(session)">
      
      <div class="title">
        {{ session.label }}
      </div>

      <div class="date">
        {{ session.sessionDate | date:'MMM d, y' }}
      </div>
      
      <div class="swing-count">
        {{ session.swingCount }}
      </div>
      
      <div class="label">
        Swings
      </div>
    </div>
  </div>
</div>
